import { render } from "./swipingCards.vue?vue&type=template&id=063ef802"
import script from "./swipingCards.vue?vue&type=script&lang=js"
export * from "./swipingCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__